import { render, staticRenderFns } from "./CommunicatingAlert.vue?vue&type=template&id=cc3deeaa&"
import script from "./CommunicatingAlert.vue?vue&type=script&lang=js&"
export * from "./CommunicatingAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports